import React from 'react';
import RenderRegistry from '../common/RenderRegistry';
import { useUI } from 'stores/UIStore';
import StateHelper from 'libs/stateHelper';
import { Button, CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import events from 'libs/events';
import { useModal } from 'components/Modal';
import http from 'libs/http';
import config from 'config/config';
import { useSnackbar } from 'notistack';

const cx = new StateHelper();

const UnitModal = (props) => {
  const [state, setState] = React.useState({
    file: { name: 'SELECT .xlsx' },
    isLoading: false,
  });
  const buttonUpload = React.useRef(null);
  const { closeModal } = useModal();
  const { snackbar } = props;

  const onFileChange = (evt) => {
    setState({ ...state, file: evt.target.files[0] });
  };

  const onUpload = async () => {
    setState({ ...state, isLoading: true });
    let fd = new FormData();
    fd.append('file', state.file);
    await http
      .post(config.app.server.url + `/units/upload`, fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        events.$emit('fetchData', {});
        snackbar('File uploaded successfully', { variant: 'success' });
      })
      .catch((err) => {
        snackbar('Error uploading file', { variant: 'error' });
      })
      .finally(() => {
        closeModal();
      });
  };

  const onUploadClick = () => {
    buttonUpload.current.click();
  };

  return (
    <div>
      {!state.isLoading ? (
        <div>
          <input
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            style={{ display: 'none' }}
            type="file"
            ref={buttonUpload}
            onChange={onFileChange}
          />
          <div className="billing-upload-field" onClick={onUploadClick}>
            {state.file.name}
          </div>
          <div class="row mt-3">
            <Button
              className="mx-1"
              onClick={onUpload}
              color="primary"
              variant="contained"
            >
              Upload
            </Button>
            <Button
              className="mx-1"
              onClick={closeModal}
              color="primary"
              variant="contained"
            >
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        <div className="billing-upload-loading">
          <CircularProgress color="primary" />
        </div>
      )}
    </div>
  );
};

const UnitUpload = (props) => {
  const ui = useUI();
  const { node, context } = props;
  const cls = props.node.className;
  const children = node.children;
  const { enqueueSnackbar } = useSnackbar();

  const { showModal, closeModal } = useModal();

  const onNewUnit = () => {
    console.log('clicked');
    showModal({
      title: 'Upload Units',
      message: <UnitModal snackbar={enqueueSnackbar} />,
    });
  };

  const componentEvents = {
    upload_unit: onNewUnit,
  };

  React.useEffect(() => {
    events.register(componentEvents);
    return () => {
      events.unregister(componentEvents);
    };
  }, []);

  return (
    <React.Fragment>
      {RenderRegistry.renderChildren(node.children, {
        ...props,
        context: context,
      })}
    </React.Fragment>
  );
};

RenderRegistry.add({
  UnitUpload,
});
